import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageHistoryService {
  private storageKey = 'pageHistory';
  private maxHistoryLength = 10;

  constructor() {}

  // Add a new page to the history
  addPage(url: string): void {
    let history = this.getHistory();
    history.push(url);

    // Keep only the last maxHistoryLength entries
    if (history.length > this.maxHistoryLength) {
      history = history.slice(history.length - this.maxHistoryLength);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(history));
  }

  // Get the full history array
  getHistory(): string[] {
    const stored = localStorage.getItem(this.storageKey);
    return [...(stored ? JSON.parse(stored) : [])].reverse();
  }

  // Clear the history
  clearHistory(): void {
    localStorage.removeItem(this.storageKey);
  }
}
